import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, ExternalLinkIcon } from 'lucide-react';
const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/YkZ8cAkm4wWJcYB3A';
export function Footer() {
  return <footer className="w-full bg-[#3A3A2E] text-[#F2EDE4] py-12 px-4 mt-auto" data-id="element-506" data-mp="32onl753ftsa0">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 text-center md:text-left" data-id="element-507" data-mp="36oxzr65apr0h">
        <div className="space-y-2" data-id="element-508" data-mp="3ugbshd7czolz">
          <h3 className="font-serif text-xl text-[#7C8062]" data-id="element-509" data-mp="3ucxs2ai99ph6">
            Top Notch Bakery
          </h3>
          <p className="text-sm opacity-80" data-id="element-510" data-mp="36d1erw44jko">Est. 2021</p>
        </div>

        <div className="flex flex-col gap-3 text-sm opacity-90" data-id="element-511" data-mp="3ldu2qoshwdu8">
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-512" data-mp="3qcnlavmn2v19">
            <MapPinIcon className="h-4 w-4 text-[#7C8062]" data-id="element-513" data-mp="2ew700loelk6h" />
            <span data-id="element-514" data-mp="3lalhzkmm4fwl">Klostergatan 7, Växjö</span>
          </a>
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-515" data-mp="3gagzjp259b3q">
            <ClockIcon className="h-4 w-4 text-[#7C8062]" data-id="element-516" data-mp="3q7lr64erdyrx" />
            <span data-id="element-517" data-mp="82qsbsqetttq">Se öppettider på Google Maps</span>
            <ExternalLinkIcon className="h-3 w-3 opacity-50" data-id="element-518" data-mp="81fqhygiyw59" />
          </a>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-519" data-mp="32w1tqajr697">
            <PhoneIcon className="h-4 w-4 text-[#7C8062]" data-id="element-520" data-mp="htd0j1vsri2e" />
            <span data-id="element-521" data-mp="huwlv6wb8jb1">0470-52 36 03</span>
          </div>
          <a href="mailto:info@topnotchbakery.se" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-522" data-mp="curzj08q0ucw">
            <MailIcon className="h-4 w-4 text-[#7C8062]" data-id="element-523" data-mp="msppbs68az7m" />
            <span data-id="element-524" data-mp="mq3gzqbikfoc">info@topnotchbakery.se</span>
          </a>
        </div>

        <div className="text-xs opacity-50" data-id="element-525" data-mp="twxv9kvlbuel">
          &copy; {new Date().getFullYear()} Top Notch Bakery.
        </div>
      </div>
    </footer>;
}